export { default as ModernDoor } from './Modern';
export { default as GladernDoor } from './Gladern';
